import { render, staticRenderFns } from "./DetalhesdaAposta.vue?vue&type=template&id=ebf30f68&scoped=true"
import script from "./DetalhesdaAposta.vue?vue&type=script&lang=js"
export * from "./DetalhesdaAposta.vue?vue&type=script&lang=js"
import style0 from "./DetalhesdaAposta.vue?vue&type=style&index=0&id=ebf30f68&prod&lang=css"
import style1 from "./DetalhesdaAposta.vue?vue&type=style&index=1&id=ebf30f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf30f68",
  null
  
)

export default component.exports